import React from 'react'

function Table() {
  return (
    <div>
      <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="relative">
        {/* Grid with horizontal and vertical lines */}
        <div className="grid grid-cols-5 grid-rows-5 gap-1">
          {/* Labels */}
          <div className="flex flex-col items-center justify-center">
            <div className="text-xs rotate-90">Top</div>
          </div>
          <div className="flex items-center justify-center">
            <div className="text-xs">Left</div>
          </div>

          {/* Grid boxes */}
          {Array.from({ length: 25 }).map((_, index) => (
            <div
              key={index}
              className="w-16 h-16 flex items-center justify-center border-2 border-gray-400"
            >
              X
            </div>
          ))}
        </div>

        {/* Horizontal and Vertical lines */}
        <div className="absolute inset-0">
          <div className="h-full w-full border-t-2 border-l-2 border-gray-500"></div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Table
